import { combineReducers } from "redux";
import encuestasReducer from "./encuestasReducer";
import initReducer from "./initReducer";
import formulario from "./formulario";
import preguntaActiva from "./preguntaActivaReducer";
import usuario from "./usuarioReducer";
import answer from "./answerReducer";
import answernew from "./answernewReducer";
import ticket from "./ticketReducer";
import preguntaCuaterna from "./preguntaCuaternaReducer";
import respuesta from "./respuestaReducer";
import reporte from "./reporteReducer";

const rootReducer = combineReducers({
  encuestas: encuestasReducer,
  init: initReducer,
  formulario: formulario,
  preguntaActiva: preguntaActiva,
  usuario: usuario,
  answer: answer,
  answernew: answernew,
  ticket: ticket,
  preguntaCuaterna: preguntaCuaterna,
  respuesta: respuesta,
  reporte: reporte,
});

export default rootReducer;
